import React from "react";
import "./dashboardtaskbarbodytabs.css";
import { useHistory } from "react-router-dom";

function DashboardTaskbarBody({ link, header, body }) {
  const history = useHistory();
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        if (link) {
          history.push({
            pathname: link,
            state: null,
            key: "",
          });
        }
      }}
      className="dashboardtaskbarbodytabs"
    >
      <div className="dashboardtaskbarbodytabs__header">{header}</div>
      <p>
        {body || "Get great blog ideas in a few clicks.Pair with the Blog Outline or Intro generator! "}
      </p>
    </div>
  );
}

export default DashboardTaskbarBody;
